export const oidcSettings = {
  authMode: process.env.AUTH_MODE || 'OIDC',
  oidcAuthEndpoint:
    process.env.OIDC_AUTH_ENDPOINT || 'http://localhost:3001/sso/authenticate',
  oidcClientId: process.env.OIDC_CLIENT_ID || 'localhost',
  oidcRedirectUrl:
    process.env.OIDC_REDIRECT_URI || 'http://localhost:8080/#/auth',
  oidcResponseType: 'code',
  oidcScope: 'openid',
};
